<script>

export default {
  name: "model-icon",
  props: {
    model: String
  },
  computed: {
    icon() {
      switch (this.model) {
        case 'Order':
          return ['fas', 'fa-shopping-cart']
        case 'Customer':
          return ['fas', 'fa-user']
        case 'Message':
          return ['fas', 'fa-envelope']
        case 'Bid':
          return ['fas', 'money-check-dollar']
        // a priced document rather than a placed one - the cart is the order
        // it may become, and the money-check is what we offer a vendor
        case 'Quote':
          return ['fas', 'file-invoice-dollar']
        case 'PO':
          return ['fas', 'fa-shopping-basket']
        case 'Inventory':
        case 'Item':
          return ['fas', 'fa-industry']
        case 'Transaction':
          return ['fas', 'fa-money-bill']
        case 'Auction':
          return ['fab', 'fa-ebay']
        case 'ItemOffer':
          return ['fas', 'fa-handshake']
        case 'Location':
          return ['fas', 'fa-warehouse']
        case 'Vendor':
          return ['far', 'building']
        default:
          return ['fas', 'fa-question']
      }
    }
  }
}
</script>

<template>
  <font-awesome-icon :icon="icon"/>
</template>

<style scoped>

</style>